import { useEffect, useContext, useState } from "react";
import { StoredValueChartConfig } from "./StoredValueConfig";
import { StoreContext } from "../../../store/Store";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";
import { applyOverrides } from "../../../utils/dataFunctions";
import { config } from "../../../d3charts/storedvalue/config";
import { Loader } from "../../../components/loader/Loader";

export const StoredValueChart = () => {
  const [store] = useContext(StoreContext);
  const [lstore] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);

  const { storedValue } = lstore;

  const [storedValueData, setStoredValueData] = useState();
  const [storedValueConfig, setStoredValueConfig] = useState();

  if (store) {
    //do nothing
  }

  useEffect(() => {
    if (storedValue.filteredData.length > 0) {
      const storedValueConfig = applyOverrides(config, {
        header: {
          text: `${refs.storedValueSelections.current.currentTicker} ${refs.storedValueSelections.current.currentHorizon}D horizon `,
        },
      });
      setStoredValueConfig(storedValueConfig);
      setStoredValueData(storedValue.filteredData);
    }
  }, [storedValue.filteredData, refs.layoutRefs, refs.storedValueSelections]);

  return storedValueConfig && storedValueData ? (
    <StoredValueChartConfig
      data={storedValueData}
      width={refs.componentSize.current["StoredValue"].width}
      height={refs.componentSize.current["StoredValue"].height}
      config={storedValueConfig}
      lRef={refs.storedValueRef}
    />
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader />
    </div>
  );
};
